import { render, staticRenderFns } from "./Semaforo2b.vue?vue&type=template&id=41606e32"
import script from "./Semaforo2b.vue?vue&type=script&lang=js"
export * from "./Semaforo2b.vue?vue&type=script&lang=js"
import style0 from "./Semaforo2b.vue?vue&type=style&index=0&id=41606e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports